<template>
  <div class="new-report full-height">
    <dashboard-header :showBetaVersion="false"></dashboard-header>
    <div class="main-content">
      <div class="container-fluid">
        <div class="row">
          
          <div class="leftNavBar">
            <left-nav-bar :groupList="getGroupList" @groupProgressDataList="currGroupProgressDataList" @updateCurrGroupObj="updatedGroupObjValue"></left-nav-bar>
          </div>

          <div class="right-container">
            <tab-selection @clickedTab="updateCurrSelectedTab"></tab-selection>
            <div class="row vertical-align margin-Top-2Perc">
              <div :class="{'col-md-2 col-lg-2': currentSelectedTab === 2, 'col-md-1 col-lg-1' : currentSelectedTab === 1}"></div>
              <div class="col-lg-4 col-md-4" id="vueMultiSelect">
                <vue-multi-select
                  search
                  :filters="filters"
                  btnClass="cssClass"
                  v-model="selectedValues"
                  :btnLabel="btnLabel"
                  :options="options"
                  :selectOptions="data" />
              </div>
              <div class="col-lg-2 col-md-2 padding-right-0px">
                <select class="form-control" v-model="selectedUserSubset">
                  <option value=-1 disabled>Select User Subset</option>
                  <option :value=constants.UserSubsetTypeEnum.FacilitatorOnly>Facilitator Only</option>
                  <option :value=constants.UserSubsetTypeEnum.ParticipantsOnly>Participants Only</option>
                  <option :value=constants.UserSubsetTypeEnum.Both>Both</option>
                </select>
              </div>
              <div class="col-lg-3 col-md-3">
                <div class="checkbox text-align-center">
                  <label>
                    <input type="checkbox" v-model="getExcludeInternalUsersValue">Exclude Internal Users
                  </label>
                </div>
              </div>
              <div class="col-md-1 col-lg-1 padding-right-0px padding-left-0px">
                <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color" @click="performUserButtonClickOperation" :disabled="hasExportServerProcessStarted" v-if="currentSelectedTab === 1">Export</button>
              </div>
              <div class="col-md-1 col-lg-1"></div>
            </div>


            <div class="row margin-bottom-1Perc margin-top-2Perc vertical-align" v-if="currentSelectedTab === 2">
              <div class="col-md-12 col-lg-12">
                
                <div class="row margin-bottom-1Perc vertical-align">
                  <div class="col-md-5 col-lg-5"></div>
                  <div class="col-md-2 col-lg-2">
                    <button type="button" class="btn black-border custom-btn white-BG" @click="updateScheduleNewReportFlag($event)">+ Create New</button>
                  </div>
                  <div class="col-md-5 col-lg-5"></div>
                </div>

              </div>
            </div>

            <div class="row margin-bottom-1Perc margin-top-2Perc vertical-align" v-if="currentSelectedTab === 1 && hasExportServerProcessStarted">
              <div class="col-md-3 col-lg-3"></div>
              <div class="col-md-1 col-lg-1 padding-right-0px">
                <div class="loader"></div>
              </div>
              <div class="col-md-6 col-lg-6 font-size-16px text-align-left padding-left-0px padding-right-0px">
                <b>&nbsp;&nbsp;<u>Status:</u>&nbsp;</b>Need to proccess {{selectedReportsForProcessing.length}}  out of {{selectedValues.length}}.
              </div>
              <div class="col-md-2 col-lg-2"></div>    
            </div>
            <!-- AK: For First Tab: i.e. Immediate Reporting -->
            <div class="table-responsive margin-Top-6Perc overflow-x-hidden" v-if="currentSelectedTab === 1 && trackServerRespState.length > 0">
              <table class="table table-striped margin-top-2Perc">
                <thead>
                  <tr>
                    <th class="text-align-center font-size-15px border-right">SR No.</th>
                    <th class="text-align-center font-size-15px border-right">Name</th>
                    <th class="text-align-center font-size-15px border-right">Status</th>
                    <th class="text-align-center font-size-15px">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(obj, index) in trackServerRespState" :key="index" class="text-color-tomato" :class="{'text-color-green' : obj.hasSuccessfullyProcessed}">
                  <td class="text-align-center border-right col-md-1 col-lg-1">{{(index + 1)}}</td>
                  <td class="text-align-center border-right col-md-3 col-lg-3">{{obj.ReportName}}</td>
                  <td class="text-align-center border-right col-md-1 col-md-1 col-lg-1">{{obj.errorMsg}}</td>
                  <td class="text-align-center cursor-default col-md-1 col-lg-1" :class="{'cursor-pointer underline-text' : obj.hasSuccessfullyProcessed}" @click="obj.hasSuccessfullyProcessed ? performUserAction('export_report', obj) : null">{{obj.hasSuccessfullyProcessed ? 'Download' : 'NA'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- AK: For Second Tab: i.e. Schedule Reporting -->
            <div class="table-responsive margin-Top-6Perc overflow-x-hidden" v-if="currentSelectedTab === 2 && scheduledReportList.length > 0">
              <table class="table table-striped margin-top-2Perc">
                <thead>
                  <tr>
                    <th class="text-align-center font-size-15px border-right">SR No.</th>
                    <th class="text-align-center font-size-15px border-right">Author</th>
                    <th class="text-align-center font-size-15px border-right">Frequency</th>
                    <th class="text-align-center font-size-15px border-right">Period</th>
                    <th class="text-align-center font-size-15px border-right">Scheduled Report Name(s)</th>
                    <th class="text-align-center font-size-15px">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(scheduledReportObj, index) in scheduledReportList" :key="index">
                  <td class="text-align-center border-right col-md-1 col-lg-1">{{(index + 1)}}</td>
                  <td class="text-align-center border-right col-md-2 col-lg-2">{{scheduledReportObj.Author}}</td>
                  <td class="text-align-center border-right col-md-1 col-lg-1">{{getScheduledReportFrequencyNameForDisplay(scheduledReportObj.Frequency)}}</td>
                  <td class="text-align-center border-right col-md-2 col-lg-2">{{scheduledReportObj.Frequency !== constants.ReportingTaskFrequency.Immediate ? getScheduledReportStartAndEndTsForDisplay(scheduledReportObj.StartTS, scheduledReportObj.EndTS) : 'NA'}}</td>
                  <td class="text-align-left border-right col-md-4 col-lg-4" v-html="getScheduledReportNamesForDisplay(scheduledReportObj.ReportTypes)"></td>
                  <td class="text-align-center col-md-2 col-lg-2">
                    <a class="cursor-pointer" @click="performUserAction('view', scheduledReportObj)"> View </a>|
                    <a class="cursor-pointer" @click="performUserAction('edit', scheduledReportObj)"> Edit </a>|
                    <a class="cursor-pointer" @click="performUserAction('delete', scheduledReportObj)"> Delete </a>
                  </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row margin-Top-3Perc">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <copyright-element class="footer"></copyright-element>
              </div>
            </div>
          </div>
        </div>
      </div>
      <update-schedule-new-report v-if="showUpdateScheduledReportPopUp" :selectedScheduledReportObj="selectedScheduledReportObj" :groupCourseCohortList="getGroupCourseCohortList" @closeOverlay="updateCloseOverlay"></update-schedule-new-report>
      <view-schedule-new-report v-if="showViewScheduledReportPopUp" :selectedScheduledReportObj="selectedScheduledReportObj" :groupCourseCohortList="getGroupCourseCohortList" @closeOverlay="updateCloseOverlay"></view-schedule-new-report>
      <schedule-new-report v-if="scheduleNewReport" :gccDataObj="objToPush" :selectedReportsForProcessing="selectedValues" @closeOverlay="updateCloseOverlay"></schedule-new-report>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postfixString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performUserConfirmedAction"></confirmation-alert>
      <loader></loader>
    </div>
    <!-- <error-page v-if="isUserGroupAdmin"></error-page> -->
  </div>
</template>

<script>
// import { courseService } from '@/server-util/course-service'
import { newReportService } from '@/server-util/new-report-service'
import { constants } from '@/utils/constants'
import csvHelper from '@/utils/csv-helper'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
import ScheduleNewReport from '@/components/new_report/ScheduleNewReport'
import UpdateScheduleNewReport from '@/components/new_report/UpdateScheduleNewReport'
import ViewScheduleNewReport from '@/components/new_report/ViewScheduleNewReport'
import CopyrightElement from '@/components/CopyrightElement'
import ErrorPage from '@/pages/Error'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import Loader from '@/components/dashboard/Loader'
import TabSelection from '@/components/new_report/TabSelection'
import LeftNavBar from '@/components/new_report/LeftNavBar'
import Header from '@/components/dashboard_v2/Header'
import { groupService } from '@/server-util/group-service'
import vueMultiSelect from 'vue-multi-select'
import 'vue-multi-select/dist/lib/vue-multi-select.css'
import { filter, findIndex, forEach } from 'lodash'
require('bootstrap/dist/css/bootstrap.min.css')
export default {
  created: function () {
    this.setDefaultValues()
    this.getGroups()
    this.getAllGroupCourseCohort()
  },
  data: function () {
    return {
      showViewScheduledReportPopUp: false,
      showUpdateScheduledReportPopUp: false,
      selectedScheduledReportObj: null,
      showConfirmationBox: false,
      prefixString: 'Are you sure you want to delete ',
      postfixString: '?',
      scheduledReportList: [],
      objToReturn: null,
      trackServerRespState: [],
      constants: constants,
      exportRespArr: null,
      showAlertDialog: false,
      errorMsg: '',
      currentSelectedTab: 1,
      groupList: [],
      groupCourseCohortList: [],
      selectedGroupObj: -1,
      btnLabel: selectedValues => selectedValues.length > 0 ? selectedValues.length === 1 ? '1 Report is selected' : selectedValues.length + ' Reports are selected' : 'Select Single/Multiple Report',
      selectedValues: [],
      selectedReportsForProcessing: [],
      data: [],
      options: {
        multi: true,
        groups: false,
        cssSelected: option => (option.selected ? { 'color': '#27345b', 'font-weight': '500', 'opacity': '1' } : { 'opacity': '0.8' })
      },
      filters: [{
        nameAll: 'Select all',
        nameNotAll: 'Deselect all',
        func () {
          return true
        }
      }],
      maxLength: constants.Element_Title_Step_Max_Length,
      selectedUserSubset: -1,
      excludeInternalUsers: true,
      groupProgressDataList: [],
      hasExportServerProcessStarted: false,
      scheduleNewReport: false
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'vue-multi-select': vueMultiSelect,
    'alert-box': AlertBox,
    'schedule-new-report': ScheduleNewReport,
    'update-schedule-new-report': UpdateScheduleNewReport,
    'view-schedule-new-report': ViewScheduleNewReport,
    'copyright-element': CopyrightElement,
    'error-page': ErrorPage,
    'loader': Loader,
    'tab-selection': TabSelection,
    'left-nav-bar': LeftNavBar,
    'dashboard-header': Header
  },
  name: 'new-report',
  methods: {
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of confirmation overlay
      this.showConfirmationBox = value
    },
    performUserConfirmedAction (value) {
      this.showConfirmationBox = false
      if (value) {
        this.deleteScheduledReportFromServer()
      }
    },
    checkAndDeleteCurrentScheduledReportFromList: function () {
      const foundIndex = findIndex(this.scheduledReportList, (obj) => {
        return obj.ReportingTaskId === this.selectedScheduledReportObj.ReportingTaskId
      })
      if (foundIndex > -1) {
        this.scheduledReportList.splice(foundIndex, 1)
      }
      this.selectedScheduledReportObj = null
    },
    deleteScheduledReportFromServer: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== '' &&
        this.selectedScheduledReportObj !== undefined &&
        this.selectedScheduledReportObj !== null &&
        this.selectedScheduledReportObj !== ''
      ) {
        this.$store.state.isLoading = true
        newReportService.deleteExistingScheduledReport(storeObj.state.access_token, this.selectedScheduledReportObj.ReportingTaskId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.checkAndDeleteCurrentScheduledReportFromList()
              this.$store.state.isLoading = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token Or Selected Scheduled Report obj is NULL hence declined DELETE EXISTING SCHEDULED REPORT FROM LIST')
      }
    },
    getScheduledReportStartAndEndTsForDisplay: function (startTs, endTs) {
      var dateToReturn = 'Not Found'
      if (startTs !== undefined && startTs !== 'undefined' && startTs !== null && startTs !== 'null' && startTs !== '') {
        dateToReturn = startTs.indexOf('Z') === -1 ? dmAdminUtils.getHumanReadableEST(startTs + 'Z') : dmAdminUtils.getHumanReadableEST(startTs)
      }
      if (endTs !== undefined && endTs !== 'undefined' && endTs !== null && endTs !== 'null' && endTs !== '') {
        dateToReturn += ' - ' + (endTs.indexOf('Z') === -1 ? dmAdminUtils.getHumanReadableEST(endTs + 'Z') : dmAdminUtils.getHumanReadableEST(endTs))
      }
      return dateToReturn
    },
    getScheduledReportNamesForDisplay: function (reportType) {
      if (reportType !== undefined && reportType !== 'undefined' && reportType !== null && reportType !== 'null' && reportType !== '') {
        var selectedReportNameInStrArr = []
        const splitReportTypeStrIntoArr = reportType.split(',')
        forEach(splitReportTypeStrIntoArr, (currReportEnum, index) => {
          selectedReportNameInStrArr.push((index + 1) + '. ' + this.getObjToPush(parseInt(currReportEnum)).name)
        })
        return selectedReportNameInStrArr.join('<br/>')
      } else {
        return 'Not Found'
      }
    },
    getScheduledReportFrequencyNameForDisplay: function (frequencyEnum) {
      if (frequencyEnum !== undefined && frequencyEnum !== 'undefined' && frequencyEnum !== null && frequencyEnum !== 'null' && frequencyEnum !== '') {
        var valueToReturn = 'Not Found'
        switch (frequencyEnum) {
          case constants.ReportingTaskFrequency.Immediate:
            valueToReturn = 'Immediate'
            break
          case constants.ReportingTaskFrequency.Daily:
            valueToReturn = 'Daily'
            break
          case constants.ReportingTaskFrequency.Weekly:
            valueToReturn = 'Weekly'
            break
          case constants.ReportingTaskFrequency.Monthly:
            valueToReturn = 'Monthly'
            break
        }
        return valueToReturn
      } else {
        return 'Not Found'
      }
    },
    updateScheduleNewReportFlag: function (event) {
      if (this.validateRequiredFieldBeforeSubmit()) {
        this.objToPush = this.getObjectToPost()
        this.scheduleNewReport = true
        this.$store.state.isOverlayVisible = true
      }
    },
    updateCloseOverlay (value) {
      const operationName = value.operationName
      const isComingFrom = value.comingFrom
      const objToAddOrUpdate = value.obj
      switch (operationName) {
        case 'close_overlay':
          this.showUpdateScheduledReportPopUp = false
          this.showViewScheduledReportPopUp = false
          this.scheduleNewReport = false
          this.$store.state.isOverlayVisible = false
          if (objToAddOrUpdate !== null) {
            if (isComingFrom === 'create') {
              this.scheduledReportList.push(objToAddOrUpdate)
            } else {
              const foundIndex = findIndex(this.scheduledReportList, (currscheduledReportObj) => {
                return currscheduledReportObj.ReportingTaskId === objToAddOrUpdate.ReportingTaskId
              })
              if (foundIndex > -1) {
                this.scheduledReportList[foundIndex] = objToAddOrUpdate
              }
            }
          } else {
            console.log('User was trying to close the current Pop-Up')
          }
          break
      }
    },
    performUserAction: function (operationName, selectedObj) {
      switch (operationName) {
        case 'export_report':
          return csvHelper.exportFromServerData(selectedObj.serverResponse, selectedObj.ReportName.replace(/ /g, ''))
        case 'edit':
          this.selectedScheduledReportObj = selectedObj
          this.showUpdateScheduledReportPopUp = true
          this.$store.state.isOverlayVisible = true
          break
        case 'view':
          this.selectedScheduledReportObj = selectedObj
          this.showViewScheduledReportPopUp = true
          this.$store.state.isOverlayVisible = true
          break
        case 'delete':
          this.selectedScheduledReportObj = selectedObj
          this.showConfirmationBox = true
          this.prefixString = 'Are you sure you want to delete '
          this.postfixString = 'selected scheduled report?'
          break
      }
    },
    currGroupProgressDataList (value) {
      this.groupProgressDataList = value
    },
    updatedGroupObjValue (value) {
      this.selectedGroupObj = value
      this.selectedValues = []
      this.selectedReportsForProcessing = []
      this.trackServerRespState = []
      this.hasExportServerProcessStarted = false
      this.excludeInternalUsers = true
      this.selectedUserSubset = -1
    },
    performUserButtonClickOperation: function () {
      if (this.validateRequiredFieldBeforeSubmit()) {
        this.selectedReportsForProcessing = this.selectedValues
        this.trackServerRespState = []
        this.hasExportServerProcessStarted = true
        this.checkAndExportReports()
      }
    },
    checkAndExportReports: function () {
      const selectedReportEnum = this.selectedReportsForProcessing[0].selectedReportEnum
      switch (selectedReportEnum) {
        case constants.NewReportType.Participant_Progress_v1:
          this.exportParticipantProgressReportV1(this.selectedReportsForProcessing[0].name)
          break
        case constants.NewReportType.Participant_Progress_v2:
          this.exportParticipantProgressReportV2(this.selectedReportsForProcessing[0].name)
          break
        case constants.NewReportType.New_Report_RemainingProgress_v2:
          this.exportRemainingProgressReport(this.selectedReportsForProcessing[0].name)
          break
        case constants.NewReportType.Client_Dashboard_V2:
          this.exportClientDashboard(this.selectedReportsForProcessing[0].name)
          break
        case constants.NewReportType.Assessment:
          this.exportRecommendationAssessmentReport(this.selectedReportsForProcessing[0].name)
          break
        case constants.NewReportType.Recommendation_Summary:
          this.exportRecommendationSummaryReport(this.selectedReportsForProcessing[0].name)
          break
        case constants.NewReportType.MP_Element_MOT_Teachback:
          this.exportMOTReport(this.selectedReportsForProcessing[0].name)
          break
        case constants.NewReportType.MP_Element_ALG:
          this.exportALGReport(this.selectedReportsForProcessing[0].name)
          break
        case constants.NewReportType.MP_Element_Mission:
          this.exportMissionReport(this.selectedReportsForProcessing[0].name)
          break
        case constants.NewReportType.MP_Element_Consolidated:
          this.exportConsolidateMPElementSummaryReport(this.selectedReportsForProcessing[0].name)
          break
        case constants.NewReportType.MCQ_Report_V2:
          this.exportMCQReport(this.selectedReportsForProcessing[0].name)
          break
        case constants.NewReportType.Reflection_Report_V2:
          this.exportRDReport(this.selectedReportsForProcessing[0].name)
          break
        case constants.NewReportType.Coursewise_Element_View_Progress_Report_V2:
          this.exportCoursewiseElementViewProgressReport(this.selectedReportsForProcessing[0].name)
          break
        case constants.NewReportType.Participant_View_Progress_Report:
          this.exportParticipantViewProgressReport(this.selectedReportsForProcessing[0].name)
          break
      }
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.selectedGroupObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group.'
        return false
      } else if (this.getUserSelectedCohortIdListValue.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select atleast one cohort.'
        return false
      } else if (this.selectedValues.length === 0) {
        this.showAlertDialog = true
        var postStrToShow = this.currentSelectedTab === 1 ? 'export' : 'schedule'
        this.errorMsg = 'Please select atleast one report for ' + postStrToShow + '.'
        return false
      } else if (this.selectedUserSubset === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select user subset.'
        return false
      }
      return true
    },
    setDefaultValues: function () {
      this.$store.state.selectedCohortIds = []
      this.data = []
      this.data.push(this.getObjToPush(constants.NewReportType.Participant_Progress_v1))
      this.data.push(this.getObjToPush(constants.NewReportType.Participant_Progress_v2))
      this.data.push(this.getObjToPush(constants.NewReportType.New_Report_RemainingProgress_v2))
      this.data.push(this.getObjToPush(constants.NewReportType.Client_Dashboard_V2))
      this.data.push(this.getObjToPush(constants.NewReportType.Assessment))
      this.data.push(this.getObjToPush(constants.NewReportType.Recommendation_Summary))
      this.data.push(this.getObjToPush(constants.NewReportType.MP_Element_MOT_Teachback))
      this.data.push(this.getObjToPush(constants.NewReportType.MP_Element_ALG))
      this.data.push(this.getObjToPush(constants.NewReportType.MP_Element_Mission))
      this.data.push(this.getObjToPush(constants.NewReportType.MP_Element_Consolidated))
      this.data.push(this.getObjToPush(constants.NewReportType.MCQ_Report_V2))
      this.data.push(this.getObjToPush(constants.NewReportType.Reflection_Report_V2))
      this.data.push(this.getObjToPush(constants.NewReportType.Coursewise_Element_View_Progress_Report_V2))
      this.data.push(this.getObjToPush(constants.NewReportType.Participant_View_Progress_Report))
    },
    getObjToPush: function (selectedReportEnum) {
      var objToPush = {
        name: '',
        selectedReportEnum: selectedReportEnum
      }
      switch (selectedReportEnum) {
        case constants.NewReportType.Participant_Progress_v1:
          objToPush.name = 'Participant Progress V1'
          break
        case constants.NewReportType.Participant_Progress_v2:
          objToPush.name = 'Participant Progress V2'
          break
        case constants.NewReportType.New_Report_RemainingProgress_v2:
          objToPush.name = 'Remaining Progress'
          break
        case constants.NewReportType.Client_Dashboard_V2:
          objToPush.name = 'Client Dashboard'
          break
        case constants.NewReportType.Assessment:
          objToPush.name = 'Recommendation Assessment'
          break
        case constants.NewReportType.Recommendation_Summary:
          objToPush.name = 'Recommendation Summary'
          break
        case constants.NewReportType.MP_Element_MOT_Teachback:
          objToPush.name = 'MP Element MOT Teachback'
          break
        case constants.NewReportType.MP_Element_ALG:
          objToPush.name = 'MP Element ALG'
          break
        case constants.NewReportType.MP_Element_Mission:
          objToPush.name = 'MP Element Mission'
          break
        case constants.NewReportType.MP_Element_Consolidated:
          objToPush.name = 'Consolidated MP Element Summary'
          break
        case constants.NewReportType.MCQ_Report_V2:
          objToPush.name = 'MCQ'
          break
        case constants.NewReportType.Reflection_Report_V2:
          objToPush.name = 'Reflection'
          break
        case constants.NewReportType.Coursewise_Element_View_Progress_Report_V2:
          objToPush.name = 'Coursewise Element View Progress'
          break
        case constants.NewReportType.Participant_View_Progress_Report:
          objToPush.name = 'Participant View Progress'
          break
      }
      return objToPush
    },
    getAlreadyScheduledReportList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        if (this.scheduledReportList === 0) {
          this.$store.state.isLoading = true
        }
        newReportService.listExistingScheduledReport(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.scheduledReportList = responseObj.data
              this.$store.state.isLoading = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING EXISTING SCHDULED REPORT LIST')
      }
    },
    updateCurrSelectedTab (value) {
      if (this.currentSelectedTab !== value) {
        this.currentSelectedTab = value
      }
      if (this.currentSelectedTab === 2) {
        this.getAlreadyScheduledReportList()
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getAllGroupCourseCohort: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Group Course Cohort list is already present or not?
        newReportService.listGetAllGroupCourseCohort(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.groupCourseCohortList = responseObj.data
            } else {
              // AK: Hide Spinner
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP COURSE COHORT LIST')
      }
    },
    getGroups: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        } else {
          _this.groupList = storeObj.state.groupList
        }
        groupService.listGroups(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              _this.groupList = responseObj.data
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    },
    getObjectToPost: function () {
      var objToReturn = {
        GroupId: this.selectedGroupObj.GroupId,
        UserSubsetType: this.selectedUserSubset,
        ExcludeInternalUsers: this.getExcludeInternalUsersValue,
        GCCData: this.bindGCCData()
      }
      return objToReturn
    },
    bindGCCData: function () {
      var gccDataArr = []
      for (var i = 0; i < this.groupProgressDataList.length; i++) {
        const gccObj = this.groupProgressDataList[i]
        var selectedCohortIds = []
        var selectedCohortIdNames = []
        for (var j = 0; j < gccObj.CohortProgressDataList.length; j++) {
          const cohortObj = gccObj.CohortProgressDataList[j]
          if (this.getUserSelectedCohortIdListValue.indexOf(cohortObj.CohortId) > -1) {
            selectedCohortIds.push(cohortObj.CohortId)
            selectedCohortIdNames.push(cohortObj.CohortName)
          }
        }
        if (selectedCohortIds.length > 0) {
          var gccDataObj = {
            GroupCourseMasterId: gccObj.GroupCourseMasterId,
            GroupCourseMasterName: gccObj.GroupName + ' :: ' + gccObj.CourseTitle + ' [' + gccObj.CourseSubTitle + ']',
            CohortIds: selectedCohortIds.join(',')
          }
          gccDataArr.push(gccDataObj)
        }
      }
      return gccDataArr
    },
    removeCurrentReportEntryFromQueue: function (currReportHumanReadableName, comingFromSuccessResp = false, errorMsg = '', serverResp) {
      var objToPush = {
        ReportName: currReportHumanReadableName,
        hasSuccessfullyProcessed: comingFromSuccessResp,
        serverResponse: serverResp,
        errorMsg: comingFromSuccessResp ? 'Successfully Processed' : errorMsg
      }
      this.trackServerRespState.push(objToPush)
      console.log('Before this.selectedReportsForProcessing: ' + this.selectedReportsForProcessing.length)
      this.selectedReportsForProcessing = filter(this.selectedReportsForProcessing, (currObj) => {
        return currObj.name !== currReportHumanReadableName
      })
      console.log('After this.selectedReportsForProcessing: ' + this.selectedReportsForProcessing.length)
      if (this.selectedReportsForProcessing.length > 0) {
        this.checkAndExportReports()
      } else {
        this.hasExportServerProcessStarted = false
      }
    },
    exportClientDashboard: function (currReportHumanReadableName) {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // this.$store.state.isLoading = true
        newReportService.getClientDashboard(storeObj.state.access_token, this.getObjectToPost()).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, true, null, responseObj.data)
              return csvHelper.exportFromServerData(responseObj.data, 'ClientDashboardReport')
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = false
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
              this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
            }
          },
          errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
          }
        )
      } else {
        console.log('Access Token is NULL hence CLIENT DASHBOARD REPORT.')
      }
    },
    exportMOTReport: function (currReportHumanReadableName) {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // this.$store.state.isLoading = true
        newReportService.getMOTReport(storeObj.state.access_token, this.getObjectToPost()).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, true, null, responseObj.data)
              return csvHelper.exportFromServerData(responseObj.data, 'MOTReport')
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = false
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
              this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
            }
          },
          errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
          }
        )
      } else {
        console.log('Access Token is NULL hence MOT REPORT.')
      }
    },
    exportMissionReport: function (currReportHumanReadableName) {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // this.$store.state.isLoading = true
        newReportService.getMissionReport(storeObj.state.access_token, this.getObjectToPost()).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, true, null, responseObj.data)
              return csvHelper.exportFromServerData(responseObj.data, 'MissionReport')
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = false
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
              this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
            }
          },
          errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
          }
        )
      } else {
        console.log('Access Token is NULL hence MISSION REPORT.')
      }
    },
    exportMCQReport: function (currReportHumanReadableName) {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // this.$store.state.isLoading = true
        newReportService.getMCQReport(storeObj.state.access_token, this.getObjectToPost()).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, true, null, responseObj.data)
              return csvHelper.exportFromServerData(responseObj.data, 'MCQReport')
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = false
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
              this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
            }
          },
          errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
          }
        )
      } else {
        console.log('Access Token is NULL hence MCQ REPORT.')
      }
    },
    exportConsolidateMPElementSummaryReport: function (currReportHumanReadableName) {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // this.$store.state.isLoading = true
        newReportService.getConsolidateMPElementSummary(storeObj.state.access_token, this.getObjectToPost()).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, true, null, responseObj.data)
              return csvHelper.exportFromServerData(responseObj.data, 'ConsolidateMPElementSummaryReport')
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = false
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
              this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
            }
          },
          errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
          }
        )
      } else {
        console.log('Access Token is NULL hence CONSOLIDATE MP ELEMENT REPORT.')
      }
    },
    exportRecommendationSummaryReport: function (currReportHumanReadableName) {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // this.$store.state.isLoading = true
        newReportService.getRecommendationSummaryReport(storeObj.state.access_token, this.getObjectToPost()).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, true, null, responseObj.data)
              return csvHelper.exportFromServerData(responseObj.data, 'RecommendationSummaryReport')
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = false
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
              this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
            }
          },
          errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
          }
        )
      } else {
        console.log('Access Token is NULL hence RECOMMENDATION SUMMARY REPORT.')
      }
    },
    exportParticipantProgressReportV1: function (currReportHumanReadableName) {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // this.$store.state.isLoading = true
        newReportService.getParticipantProgressReportV1(storeObj.state.access_token, this.getObjectToPost()).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, true, null, responseObj.data)
              return csvHelper.exportFromServerData(responseObj.data, 'ParticipantProgressReportV1')
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = false
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
              this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
            }
          },
          errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
          }
        )
      } else {
        console.log('Access Token is NULL hence RECOMMENDATION REPORT.')
      }
    },
    exportParticipantViewProgressReport: function (currReportHumanReadableName) {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // this.$store.state.isLoading = true
        newReportService.getParticipantViewProgressReport(storeObj.state.access_token, this.getObjectToPost()).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, true, null, responseObj.data)
              return csvHelper.exportFromServerData(responseObj.data, 'ParticipantViewProgressReport')
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = false
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
              this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
            }
          },
          errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
          }
        )
      } else {
        console.log('Access Token is NULL hence RD REPORT.')
      }
    },
    exportCoursewiseElementViewProgressReport: function (currReportHumanReadableName) {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // this.$store.state.isLoading = true
        newReportService.getCoursewiseElementViewProgressReport(storeObj.state.access_token, this.getObjectToPost()).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, true, null, responseObj.data)
              return csvHelper.exportFromServerData(responseObj.data, 'CoursewiseElementViewProgressReport')
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = false
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
              this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
            }
          },
          errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
          }
        )
      } else {
        console.log('Access Token is NULL hence RD REPORT.')
      }
    },
    exportRDReport: function (currReportHumanReadableName) {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // this.$store.state.isLoading = true
        newReportService.getRDReport(storeObj.state.access_token, this.getObjectToPost()).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, true, null, responseObj.data)
              return csvHelper.exportFromServerData(responseObj.data, 'RDReport')
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = false
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
              this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
            }
          },
          errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
          }
        )
      } else {
        console.log('Access Token is NULL hence RD REPORT.')
      }
    },
    exportRecommendationAssessmentReport: function (currReportHumanReadableName) {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // this.$store.state.isLoading = true
        newReportService.getRecommendationAssessmentReport(storeObj.state.access_token, this.getObjectToPost()).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, true, null, responseObj.data)
              return csvHelper.exportFromServerData(responseObj.data, 'RecommendationAssessmentReport')
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = false
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
              this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
            }
          },
          errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
          }
        )
      } else {
        console.log('Access Token is NULL hence RD REPORT.')
      }
    },
    exportParticipantProgressReportV2: function (currReportHumanReadableName) {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // this.$store.state.isLoading = true
        newReportService.getParticipantProgressReportV2(storeObj.state.access_token, this.getObjectToPost()).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, true, null, responseObj.data)
              return csvHelper.exportFromServerData(responseObj.data, 'ParticipantProgressReportV2')
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = false
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
              this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
            }
          },
          errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
          }
        )
      } else {
        console.log('Access Token is NULL hence PARTICIPANT PROGRESS REPORT.')
      }
    },
    exportRemainingProgressReport: function (currReportHumanReadableName) {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // this.$store.state.isLoading = true
        newReportService.getRemainingProgressReport(storeObj.state.access_token, this.getObjectToPost()).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, true, null, responseObj.data)
              return csvHelper.exportFromServerData(responseObj.data, 'RemainingProgressReport')
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = false
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
              this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
            }
          },
          errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
          }
        )
      } else {
        console.log('Access Token is NULL hence REMAINING PROGRESS REPORT.')
      }
    },
    exportALGReport: function (currReportHumanReadableName) {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // this.$store.state.isLoading = true
        newReportService.getALGReport(storeObj.state.access_token, this.getObjectToPost()).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, true, null, responseObj.data)
              return csvHelper.exportFromServerData(responseObj.data, 'ALGReport')
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = false
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
              this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
            }
          },
          errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.removeCurrentReportEntryFromQueue(currReportHumanReadableName, false, this.errorMsg, null)
          }
        )
      } else {
        console.log('Access Token is NULL hence ALG REPORT.')
      }
    }
  },
  computed: {
    getGroupCourseCohortList: {
      get: function () {
        return this.groupCourseCohortList
      },
      set: function (newValue) {
        this.groupCourseCohortList = newValue
      }
    },
    getGroupList: {
      get: function () {
        return this.groupList
      },
      set: function (newValue) {
        this.groupList = newValue
      }
    },
    getExcludeInternalUsersValue: {
      get: function () {
        return this.excludeInternalUsers
      },
      set: function (newValue) {
        this.excludeInternalUsers = newValue
      }
    },
    getUserSelectedCohortIdListValue: {
      get: function () {
        return this.$store.state.selectedCohortIds
      }
    }
  }
}
</script>

<style scoped>
.underline-text {
  text-decoration: underline;
}
.cursor-pointer {
  cursor: pointer !important;
}
.cursor-default {
  cursor: default;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.unenroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.text-align-center {
  text-align: center;
}
.full-height {
  min-height: 100vh;
}
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.font-size-15px {
  font-size: 15px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.new-report {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
.text-color-tomato {
  color: red;
}
.text-color-green {
  color: green !important;
}
.border-red {
  border: 1px solid red;
}
.background-color-red {
  background-color: red;
}
.cf-border {
  border: 1px solid black;
}
.left-color-border {
  border: 1px solid red;
}
.right-color-border {
  border: 1px solid green;
}
.leftNavBarBG {
  background-color: #34495e;
  /*border:1px solid #34495e; */
}
.font-size-14px {
  font-size: 30px;
}
.position-Fixed {
  position: fixed;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.fullHeight {
  height: 100% !important;
}
.fi-border {
  border: 1px solid white;
}
.footer-img {
  margin: 0 auto !important;
  display: block;
  position: absolute;
  bottom: 0;
  width: 30%;
}
.center-block {
  margin-left: auto;
  margin-right: auto;
  display: block;
}
.text-center {
  text-align: center;
}
.margin-Top-14Perc {
  margin-top: 14%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-8Perc {
  margin-top: 8%;
}
.padding-top-8perc {
  padding-top: 8%;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.margin-Top-5Perc {
  margin-top: 5%;
}
.admin-Panel-BG {
  background-color: #f39c12;
}
.text-align-left {
  text-align: left;
}
.margin-Left-4Perc {
  margin-left: 4%;
}
.admin-Panel-Padding {
  padding: 0.1% 0% 0.1% 2%;
}
.font-size-2vw {
  font-size: 2vw;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.loader {
  border: 3px solid #f3f3f3; /* Light grey */
  border-top: 3px solid #2c3e50; /* Blue */
  border-radius: 50%;
  width: 23px;
  height: 23px;
  margin: auto;
  float: right;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.footer{
  /* position: fixed; */
    left: 0;
    bottom: 0;
    width: 100%;
    /* background-color: red; */
    /* color: white; */
    text-align: center;
    margin-bottom: 1%;
    font-size: 12px;
}

.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.padding-top-15px {
  padding-top: 15px;
}
.width-20perc {
  width: 20%;
}
.width-80perc {
  width:80%;
}
.d-inlineBlock {
  display: inline-block;
}
.float-left {
  float:left;
}
.display-flex {
  display: flex;
}
.justify-content-center {
  justify-content: center;
}
.padding-left-20px {
  padding-left: 20px;
}
.leftNavBar {
  width: 20%;
  /* display: inline-block; */
  float: left;
  padding-top: 8%;
  background-color: #dcdcdc;
  height: 91%;
  position: fixed;
  z-index: 1;
  top: 70px;
  left: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 15px;
}
.right-container {
  width: 80%;
  /* display: inline-block; */
  float: right;
  padding-left: 20px;
  padding-top: 8%;
}
::-webkit-scrollbar,
scrollbar {
  display: none;
}
.font-size-18px {
  font-size: 18px;
}
.black-border {
  border: 1px solid #aaa;
}
.align-items-center {
  align-items: center;
}
.text-align-right {
  text-align: right;
}
.padding-left-0px {
  padding-left: 0px;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12!important;
  border: 1px solid #f39c12!important;
}
.gray-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px!important;
}
.white-BG {
  background-color: #fff;
}
.padding-right-0px {
  padding-right: 0px;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
</style>
<style>
#vueMultiSelect .select {
  width: 100%;
}
#vueMultiSelect button.btn-select {
  min-width: 100%;
}
#vueMultiSelect .select .checkboxLayer {
  width: 100%;
}
#vueMultiSelect .select .helperButton {
  width: 100px !important;
  color: #000;
}
#vueMultiSelect .select .helperButton:hover {
  background-color: #ffffff;
  color: #000;
}
#vueMultiSelect ul>li .margin-left-20 {
  background-color: #fff;
  word-wrap: break-word;
  display: inline-block;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: normal;
  line-break: strict;
  hyphens: none;
  -webkit-hyphens: none;
  -moz-hyphens: none;
}
.opacity-0 {
  opacity: 0;
}
.float-left {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/NewReport.vue